export default [
  {
    path: '/admin/branches',
    name: 'branch',
    meta: { requiresAuth: true },
    component: () => import('@/pages/corporate/branch')
  },
  {
    path: '/admin/branches/create',
    name: 'branch-create',
    meta: { requiresAuth: true },
    component: () => import('@/pages/corporate/branch/create')
  },
  {
    path: '/admin/branches/:id/edit',
    name: 'branch-edit',
    meta: { requiresAuth: true },
    component: () => import('@/pages/corporate/branch/edit')
  }
]
